export const NAME = 'attachments';
